import React from 'react';
import { Size, getSize } from './utils';

interface Props {
    color: string;
    size?: Size;
}

export const CrossIcon: React.FC<Props> = ({ color, size = 's' }) => {
    const sizePx = getSize(size);

    return (
        <svg width={sizePx} height={sizePx} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.207 2.207A1 1 0 0013.793.793L8 6.586 2.207.793A1 1 0 00.793 2.207L6.586 8 .793 13.793a1 1 0 101.414 1.414L8 9.414l5.793 5.793a1 1 0 001.414-1.414L9.414 8l5.793-5.793z"
                fill={color}
            />
        </svg>
    );
};
